import {Button} from './Button';
import {Header} from './Header';
import {TabLoader} from './TabLoader';
import {Background} from './Background';
import {ScrollToTop} from './ScrollToTop';
import {BlockHeading} from './BlockHeading';
import {BottomTabBar} from '../navigation/BottomTabBar';
import {SearchableDropdown} from './SearchableDropdown';
import {SharedDocToggle} from './SharedDocToggle';

export const components = {
  Button,
  Header,
  TabLoader,
  Background,
  ScrollToTop,
  BottomTabBar,
  BlockHeading,
  SearchableDropdown,
  SharedDocToggle,
};
